// Module
var code = `<table class="table" ng-table="\$ctrl.checkbookDetailsConfig">

  <div class="checkbook-bar-container">
    <div>
      <div class="checkbook-bar">

        <select
            ng-model="\$ctrl.checkbookId"
            ng-options="c.id as c.label for c in \$ctrl.checkbooks"
            ng-disabled="\$ctrl.checkbooks.length < 2"
            ng-change="\$ctrl.selectCheckbook()">
          <option value="" ng-if="!\$ctrl.checkbooks || \$ctrl.checkbooks.length > 1">(All checkbooks)</option>
        </select>

        <button
            class="btn btn-danger"
            type="button"
            command-access="RemoveCheckbook"
            ng-if="\$ctrl.checkbookId"
            ng-disabled="\$ctrl.checkbook.hasUsedChecks"
            ng-click="\$ctrl.remove(\$ctrl.checkbookId)">
          Remove
        </button>

        <button
            class="btn btn-danger"
            type="button"
            command-access="CancelCheckbook"
            ng-if="\$ctrl.checkbookId"
            ng-disabled="\$ctrl.checkbook.status === 'CANCELED'"
            ng-click="\$ctrl.cancel(\$ctrl.checkbookId)">
          Cancel
        </button>

        <button
            class="btn btn-warning"
            type="button"
            command-access="UpdateCheckbook"
            ng-if="\$ctrl.checkbookId"
            ng-click="\$ctrl.edit(\$ctrl.checkbookId)">
          Edit
        </button>
      </div>
      <div class="checkbox-bar">
        <select
            ng-model="\$ctrl.checkStatus"
            ng-options="c.id as c.label for c in \$ctrl.checkStatuses"
            ng-change="\$ctrl.selectCheckbook()"
            ng-disabled="\$ctrl.checkbooks.length === 0">
          <option value="">(All statuses)</option>
        </select>
      </div>
    </div>
    <button
      type="button"
      class="btn btn-primary checkbook-print"
      ng-if="\$ctrl.isPrintActive"
      ng-click="\$ctrl.print()">
      Print
    </button>
  </div>

  <!-- List of checkbook(s) entries -->
  <tr ng-repeat="item in \$data">
    <td data-title="'No'">{{item.lineNo + 1}}.</td>
    <td data-title="'Status'">{{item.status | translate:'CHECKBOOK_ENTRY_STATUS'}}</td>
    <td data-title="'BRSTN'">{{item.brstn}}</td>
    <td data-title="'Check number'">{{item.checkNumber}}</td>
    <td data-title="'Amount'">{{item.amount | nxCurrency}}</td>
    <td data-title="'Registered on'">{{item.registeredOn | prettyDate}}</td>
    <td data-title="'MICR'">{{\$ctrl.getMicrText(item)}}</td>
  </tr>

</table>

`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/checkbook/checkbook-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;